export enum userUrls {
    authenticatedUser = "users/authenticated-user",
    password = "users/password",
}